import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useMemo as E } from "react";
import { useTranslation as C } from "react-i18next";
import { isObject as _, isDefined as P, isNumberString as A, formatDecimal as $, formatCurrency as g } from "@perxis-auto/shared";
import { useFinalResult as D, useStages as R } from "@perxis-auto/trade-in-sdk";
import { Button as S } from "@perxis-auto/ui-kit/lib/components/Button";
import { Row as n, Col as r } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Icon as b } from "@perxis-auto/ui-kit/lib/components/Icon";
import { Typography as s } from "@perxis-auto/ui-kit/lib/components/Typography";
import { APP as B } from "../../../shared/config/app.js";
import { APP_EVENTS as V, APP_EVENT_BUTTONS as j } from "../../../shared/config/events.js";
import { useAppContext as w } from "../../../shared/lib/app/context/appContext.js";
import { eventService as I } from "../../../shared/lib/event/eventService.js";
import { SUCCESS_TABLE_FIELD_IDS as L } from "../lib/config/index.js";
function Z() {
  var u, h, f, v;
  const { data: t } = D(), { service: m } = R(), { onReset: k, onSuccess: d } = w(), { t: c } = C(B.name), p = `${((h = (u = t.brand) == null ? void 0 : u.value) == null ? void 0 : h.text) || ""} ${((v = (f = t.model) == null ? void 0 : f.value) == null ? void 0 : v.text) || ""}`.trim(), N = E(() => L.map((l) => {
    var x;
    const a = t[l];
    if (!a || !_(a) || !P(a.value))
      return;
    let o;
    return _(a.value) ? o = (x = a.value) == null ? void 0 : x.text : A(a.value) ? o = $(Number(a.value)) : o = a.value, {
      key: l,
      label: a.label,
      value: o
    };
  }).filter((l) => !!l), [t]), T = () => {
    I.sendEvent(V.ButtonClicked, { id: j.SAVE_RESULT }), d == null || d(t);
  }, y = t.min && t.max ? `${g(Number(t.min), { hasCurrency: !1 })} — ${g(Number(t.max))}` : c("successStage.estimatedPrice.noData");
  return /* @__PURE__ */ i(n, { gutter: [0, "vertical-yellow"], children: [
    /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ i(n, { gutter: [0, "vertical-sky"], className: "pa-trade-in-card", children: [
      !!p.length && /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(s.Title, { className: "pa-trade-in-card__title", color: "darkest", level: "h3", children: p }) }),
      /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ i(n, { gutter: [0, "vertical-green"], children: [
        /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(n, { className: "pa-trade-in-table", children: N.map((l) => /* @__PURE__ */ i(r, { span: 24, className: "pa-trade-in-table__item", children: [
          /* @__PURE__ */ e(s.Text, { className: "pa-trade-in-table__label", color: "dark", level: "small", children: l.label }),
          /* @__PURE__ */ e(s.Text, { className: "pa-trade-in-table__value", color: "darkest", level: "small", children: l.value })
        ] }, l.key)) }) }),
        /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ i(n, { gutter: [0, "vertical-purple"], className: "pa-trade-in-price", children: [
          /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(s.Text, { className: "pa-trade-in-price__label", color: "dark-light", level: "main", children: ` ${c("successStage.estimatedPrice.title")}${m != null && m.disclaimer_text ? "*" : ""}` }) }),
          /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(s.Text, { className: "pa-trade-in-price__value", color: "darkest", level: "h3", children: y }) })
        ] }) })
      ] }) })
    ] }) }),
    /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ i(n, { gutter: [16, "vertical-sky"], children: [
      /* @__PURE__ */ e(r, { xs: { flex: "0 0 100%" }, sm: { flex: "none" }, children: /* @__PURE__ */ e(
        S,
        {
          type: "primary",
          icon: /* @__PURE__ */ e(b, { name: "forward", sticker: "trade-in-instock-save-result-icon" }),
          onClick: T,
          children: c("successStage.save")
        }
      ) }),
      /* @__PURE__ */ e(r, { xs: { flex: "0 0 100%" }, sm: { flex: "none" }, children: /* @__PURE__ */ e(
        S,
        {
          type: "ghost",
          icon: /* @__PURE__ */ e(b, { name: "refresh", sticker: "trade-in-instock-refresh-icon" }),
          onClick: k,
          children: c("successStage.reset")
        }
      ) })
    ] }) })
  ] });
}
export {
  Z as SuccessStage
};
